import * as Sentry from "@sentry/vue";
export default {
  methods: {
    throwSentryError(error, errorTags) {
      Sentry.captureException(error, {
        tags: errorTags,
      });
    },
    sendCaptureMessage(message) {
      Sentry.captureMessage(message);
    },
  },
};
